import { HttpTypes } from 'src/http';
import { HttpError } from 'src/http/errors/http-error';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { Either } from 'src/utils/either';

export class BenefitsConfigRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getData(params?: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefit-config/get-all`,
      params,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async create(body: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefit-config/create`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async update(id: string, body: any): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `benefit-config/update/${id}`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async changeStatus(id: string): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `benefit-config/change-status/${id}`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async delete(id: string): Promise<Either<HttpError, any | undefined>> {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: `benefit-config/delete/${id}`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
